module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.consent && _vm.consent.Intent) ? _c('v-card', [_c('v-card-text', [_c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [_c('div', {
    staticClass: "headline mb-1"
  }, [_vm._v(_vm._s(_vm.consent.DataOwnerCode))]), _vm._v(" "), _c('div', {
    staticClass: "title mb-3"
  }, [_vm._v(_vm._s(_vm.consent.Intent.ShortDescription))]), _vm._v(" "), _c('div', {
    staticClass: "subheading mb-3"
  }, [_vm._v(_vm._s(_vm.consent.Intent.Description))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "label body-2 grey--text text--darken-1",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v("Expires by")]), _vm._v(" "), _c('v-flex', {
    staticClass: "body-2",
    attrs: {
      "xs11": ""
    }
  }, [_vm._v(_vm._s(_vm.userReadable(_vm.consent.Expiration)))])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "label caption grey--text text--darken-1",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v("Issuer")]), _vm._v(" "), _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "xs11": ""
    }
  }, [_vm._v(_vm._s(_vm.consent.IntentIssuerCode))])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "label caption grey--text text--darken-1",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v("Intent")]), _vm._v(" "), _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "xs11": ""
    }
  }, [_vm._v(_vm._s(_vm.consent.IntentCode))])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "label caption grey--text text--darken-1",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v("Owner")]), _vm._v(" "), _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "xs11": ""
    }
  }, [_vm._v(_vm._s(_vm.consent.DataOwnerCode))])], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-271ce24c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Consent.vue
// module id = 389
// module chunks = 0